import { FC } from 'react';
import styles from 'styles/components/PrivacyPolicy.module.scss';

const PrivacyPolicy: FC = () => {
	return (
		<div>
			<div className={styles.container}>
				<p className='MsoNormal' style={{ textAlign: 'center' }}>
					<b>
						<h1 lang='EN-CA' style={{ fontSize: '14.0pt' }}>
							OrderSimply Privacy Policy
						</h1>
					</b>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Order Simply, Inc. recognizes and respects the importance of maintaining the
						privacy of customers, registered bars, brewers, and licensees (“Members”)
						and users and has established this Privacy Policy as a result. This Privacy
						Policy applies if you are a Canadian visitor of the websites and mobile apps
						or apps (collectively “Website”) that link to this Privacy Policy regardless
						of how you use or access it, which are owned by Order Simply, Inc. If you
						are not a resident of Ontario please discontinue use of our Website. Below
						we describe why we collect information from you, what information we
						collect, how we collect it, what we use the information for, how we share it
						and how you can instruct us if you prefer to limit the use or sharing of
						that information. This Privacy Policy is part of the Terms of Use, which
						governs your use of our Website.{' '}
					</span>
				</p>
				<p className='MsoNormal'>
					<strong>Table of Contents</strong>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#why'>Why do we collect information?</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#what'>What information do we collect?</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#how'>How do we use the information we collect about you?</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#sharing'>How do we share the information we collect about you?</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#consent_to_transfer_information'>
							Consent to transfer&nbsp;of personal information outside of Canada
						</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#links'>Links&nbsp;to third-party websites</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#your_security'>Your security</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#your_password'>Your Password</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#how_to_limit'>
							How to limit the use and sharing of your information
						</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#retention_of_information'>Retention of personal information</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#your_consent'>Your consent</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#changes'>Changes to this Policy</a>
					</span>
				</p>
				<p className='MsoNormal' style={{ marginBottom: '6.0pt' }}>
					<span lang='EN-CA'>
						<a href='#contact_us'>Contact us</a>
					</span>
				</p>
				<h1>
					<div id='why' />
					<span lang='EN-CA'>Why do we collect information?&nbsp;</span>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Order Simply, Inc. provides our customers, Members, and users with
						reciprocal access to local bars and breweries, excellent customer service, ,
						and an overall pleasant interactive experience. In order to do this, we need
						to collect personal information.{' '}
					</span>
					<span lang='EN-CA'>
						When used in this Privacy Policy, and consistent with applicable Canadian
						data protection laws, personal information means “any information about an
						identifiable individual”. Information that is aggregated and/or
						de-identified and cannot be associated with an identifiable individual is
						not considered to be personal information.
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						For more information on how we use personal information, please review{' '}
						<a href='#how'>How do we use the information we collect about you?</a>
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>&nbsp;</span>
				</p>
				<h1>
					<div id='what' />
					<strong>
						<span lang='EN-CA'>What information do we collect?</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						We limit the collection of personal information to what is reasonably
						required to fulfill the purposes for which it was collected. We collect
						personal information directly from you, when you interact with us through
						our Website and emails, and automatically through online technologies.{' '}
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpFirst'
					style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
					<div id='ReadMoreCollection' />
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>
							Personal information we collect directly from you when you interact with
							us through our Website and emails.{' '}
						</span>
					</b>
					<span lang='EN-CA'>
						We may collect personal information about you when you interact with us
						through our Website and emails, for instance: when you place an order,
						participate in our forums, surveys, contests, sweepstakes, promotions,
						content submissions, chats, bulletin boards, discussion groups, requests for
						suggestions, membership registrations, and in connection with other
						activities, services, products and resources we make accessible through or
						available on the Website, or any of our affiliated sites. We may collect the
						following information:
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>your business name;</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>
						contact information (e.g. address, telephone number, email address);
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>AGCO and CRA licenses information;</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>photographs;</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>
						products purchased and any relevant promotion code and information; and
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>
						any other information you provide to us, including User Submissions (as
						defined in the Terms and Conditions of Website Use, hereafter referred to as
						“Terms of Use.”).
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Online technologies. </span>
					</b>
					<span lang='EN-CA'>
						We or our third party service providers may collect information<b> </b>
						automatically through online technologies when you visit the Website,
						including “cookies” and “Action Tags”.
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<b>
						<span lang='EN-CA'>Cookies.</span>
					</b>
					<span lang='EN-CA'>
						{' '}
						A “cookie” is a small file stored on your computer by a website which gives
						you a numeric user ID and stores certain information about your activity on
						the site. We use cookies to let us know that you are a prior customer, user
						or Member and to provide certain features to you. We currently do not use
						this technology, but it is used by third parties through our Website, such
						as Google Analytics, Algolia, and Stripe (when directed to their website
						upon sign up). These companies offer analytics or deliver targeted ads
						online or through apps. They use technology and collect device identifiers
						such as your IP address or mobile UDID, browser setting, operating system,
						referring domain, language preferences, mobile carrier if you are using a
						mobile device, and other general information such as geo-location,
						information about your Internet browsing (collected through online
						behavioral tracking tools). For development purposes Google Analytics will
						track user behaviour across the site,&nbsp;such as number of
						page&nbsp;views,&nbsp;the user’s location, the time on the Website, and when
						purchases have been made. We encourage you to be familiar with any
						third-parties’ use of cookies when using their websites or services.. Most
						web browsers automatically accept cookies, but most allow you to instruct
						your browser to prevent the use of cookies.{' '}
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpLast'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<b>
						<span lang='EN-CA'>Action Tags.</span>
					</b>
					<span lang='EN-CA'>
						{' '}
						Our Website also uses a common web technology called “action tags” (also
						called single pixel gifs or web beacons) to anonymously track purchase,
						usage and other web information. Action tags (including third-party tags)
						may be used to provide data to third parties for tracking purposes. However,
						no personal information is collected or transferred using action tags on our
						Website.&nbsp;
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Through these technologies, we may collect information you enter even if you
						cancel or do not complete the intended use, registration or order process.
					</span>
				</p>
				<h1>
					<div id='how' />
					<strong>
						<span lang='EN-CA'>
							How do we use the information we collect about you?&nbsp;
						</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>W</span>
					<span lang='EN-CA'>
						e use your personal information with your consent or as permitted or
						required by law, and for the following purposes:
					</span>
				</p>
				<p className='MsoListParagraphCxSpFirst' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to communicate with you, including to answer your inquiries, questions or
						requests;
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to process your orders and enable your participation in our programs and
						services;
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to provide an enhanced and more personalized interactive shopping
						experience;{' '}
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to inform you, including by email, of offers and discounts from Order
						Simply, Inc. or other websites and companies that we own or work with in
						providing you the best service and products possible;{' '}
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpMiddle'
					style={{ textAlign: 'justify', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to improve or develop new products, services, programs, promotions, contests
						or events, and to better understand our customer base and behaviour;{' '}
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to deliver advertisement relevant to you on our Website and other
						third-party websites
					</span>
				</p>
				<p className='MsoListParagraphCxSpLast' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<span lang='EN-CA'>
						to provide information about your product or service to other approved
						account holders on the platform to facilitate business between our approved
						account holders.
					</span>
				</p>
				<h1>
					<div id='sharing' />
					<span lang='EN-CA'>How do we share the information we collect about you?</span>
				</h1>
				<p className='MsoNormal' style={{ textAlign: 'justify' }}>
					<span lang='EN-CA'>
						We may share your personal information with our affiliates and with service
						providers (companies operating on our behalf) for the purposes described in
						this Privacy Policy and in accordance with applicable law. We will not share
						your personal information with any non‑affiliated third party without your
						prior consent, other than as provided in this Privacy Policy or as otherwise
						authorized by applicable law.{' '}
					</span>
				</p>
				<p className='MsoNormal'>
					<div id='ReadMoreSharing' />
					<span lang='EN-CA'>We may share personal information as follows:</span>
				</p>
				<p className='MsoListParagraphCxSpFirst' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Affiliates. </span>
					</b>
					<span lang='EN-CA'>
						We may share personal information with our affiliates for the purposes
						described in this Privacy Policy. “Affiliates” are those persons or entities
						directly or indirectly controlling, controlled by, or under common control
						with Order Simply, Inc.{' '}
					</span>
					<span lang='EN-CA'>
						This allows Order Simply, Inc. and our Affiliates to comply with applicable
						laws, regulations and requirements and ensures that your information is
						consistent, accurate and up-to-date.{' '}
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Service providers</span>
					</b>
					<span lang='EN-CA'>
						. We may share personal information with service providers, subcontractors
						or agents acting on our behalf in compliance with this Privacy Policy. This
						may include service providers who provide services necessary to operate this
						Website or to process any orders or registrations or to conduct any
						promotions, contests, or sweepstakes you participate in
					</span>
					<span lang='EN-CA'>
						. We provide them with a limited amount of information which is necessary in
						order for them to provide the services required. They are prohibited from
						using the information for purposes other than to facilitate and carry out
						the services they have been engaged to provide.
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Other approved accounts. </span>
					</b>
					<span lang='EN-CA'>
						By the nature of our Website, some information will need to be shared
						between bars and breweries. Most information collected from the bar partners
						will not be shared with the breweries, other than the name of the bar, the
						email provided, and the city it is located in. The brewery may then choose
						to send e-mails, which the bars can opt out of. The information collected
						from breweries will be used to list their products on the Website, including
						the name, city and required contact information.
					</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Sale or transfer of business or other transaction.</span>
					</b>
					<span lang='EN-CA'>
						{' '}
						In the event of a merger, consolidation, or sale or transfer of all or
						substantially all of the assets or business of Order Simply, Inc. by, with,
						or into another company (a “Successor”), one of the assets which would
						generally be transferred is the information we collect from our customers,
						Members and users.{' '}
					</span>
					<span lang='EN-CA'>
						In the event the transaction is completed, your personal information will
						remain protected by applicable privacy laws. In the event the transaction is
						not completed, we will require the other party not to use or disclose your
						personal information in any manner whatsoever and to completely delete such
						information, in compliance with applicable laws.
					</span>
					<span lang='EN-CA'>&nbsp;</span>
				</p>
				<p className='MsoListParagraphCxSpMiddle' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'>Other permitted reasons. </span>
					</b>
					<span lang='EN-CA'>
						We may disclose any information you provide to us (i) when we believe
						disclosure to be appropriate to comply with any law, regulation, or
						governmental or law enforcement request, or to comply with judicial process;
						(ii) to protect the rights or property of Order Simply, Inc., its
						Affiliates, users, customers, recipients, Members, Sponsors, Providers,
						Licensors, or Merchants (as such terms are defined in the Terms of
						Use).&nbsp;
					</span>
				</p>
				<p className='MsoListParagraphCxSpLast' style={{ textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<b>
						<span lang='EN-CA'> </span>
					</b>
				</p>
				<h1>
					<div id='consent_to_transfer_information' />
					<strong>
						<span lang='EN-CA'>
							Consent to transfer&nbsp;of personal information outside of Canada
						</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Order Simply, Inc. is operated exclusively in Ontario. However, the
						information we collect is stored on servers located in the United States.{' '}
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						By using the Website or providing us with your information, you hereby
						consent to this transfer.
					</span>
					<span lang='EN-CA'>
						As a result, your personal information will be subject to the law of the
						United States, including any law permitting or requiring disclosure of the
						information to the government, government agencies, courts and law
						enforcement in these jurisdictions.
					</span>
					<span lang='EN-CA'>
						{' '}
						Although we will collect and use your information only as stated in this
						Privacy Policy, laws generally applicable to the protection of personal data
						in the United States may not be as stringent as those in Canada.
					</span>
				</p>
				<h1>
					<div id='links' />
					<strong>
						<span lang='EN-CA'>Links&nbsp;to third-party websites</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Order Simply, Inc. wants you to be aware that when you click on links and/or
						ad banners that take you to third-party websites, you will be subject to the
						privacy policies and terms of use of those third-party websites, not ours.
						While we support the protection of privacy on the Internet, we cannot be
						responsible for the actions of third parties. We encourage you to read the
						posted privacy statement and user terms and conditions whenever interacting
						with, and prior to providing any personal information to, any other website.
					</span>
				</p>
				<h1>
					<div id='your_security' />
					<strong>
						<span lang='EN-CA'>Third-party service providers</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						When you place an Order through our Website, you will be prompted to enter
						your payment information through the embedded Stripe function for secure
						payment processing. Our website enables access to Stripe, but is not
						responsible for payment processing or the information collected therein. We
						may also enter into agreements with other third party software to facilitate
						features of our Website. When you use our Website, you agree the terms and
						conditions and privacy policy of the third-party program, software or
						service you are redirected to or interacting with. We encourage you to read
						the posted privacy statement and user terms and conditions whenever
						interacting with, and prior to providing any personal information to, any
						other website.
					</span>
				</p>
				<h1>
					<div id='your_password' />
					<span lang='EN-CA'>Your Password</span>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Portions of the Website (such as our Member registration) may require
						registration and log-in processes in which you will select a user ID and
						password (collectively, the “Password”). Any Password provided to you will
						be the exclusive property and confidential information of Order Simply, Inc.
						and may be used by you solely for your individual use of this Website. You
						are responsible for maintaining the confidentiality of any Password provided
						to you and any Password you create yourself. All activities that occur using
						your Password are your responsibility, whether or not authorized by you. You
						agree to immediately notify us of any unauthorized use of your Password or
						accounts.&nbsp;
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Once you create your own Password, it is securely stored on Google’s
						authentication services. We do not have access to your Password.
					</span>
				</p>
				<h1>
					<div id='how_to_limit' />
					<span lang='EN-CA'>How to limit the use and sharing of your information</span>
				</h1>
				<p
					className='MsoListParagraphCxSpFirst'
					style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<strong>
						<span lang='EN-CA'>Sharing with Third Parties</span>
					</strong>
					<strong>
						<span lang='EN-CA' style={{ fontWeight: 'normal' }}>
							.{' '}
						</span>
					</strong>
					<span lang='EN-CA'>
						If you prefer not to have us provide personal information about you to third
						party advertising partners, please let us know by either:
					</span>
				</p>
				<p
					className='MsoListParagraphCxSpLast'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>Writing us at:</span>
				</p>
				<p
					className='MsoNormal'
					style={{
						marginTop: '0in',
						marginRight: '0in',
						marginBottom: '0in',
						marginLeft: '53.85pt',
					}}>
					<span lang='EN-CA'>Order Simply, Inc. </span>Suite 1602- 757 Victoria Park
					Avenue, Toronto, Ontario.{' '}
				</p>
				<p className='MsoNormal' style={{ marginLeft: '53.85pt' }}>
					&nbsp;
				</p>
				<p className='MsoNormal' style={{ marginLeft: '53.85pt' }}>
					<span lang='EN-CA'>
						If you have a catalog, brochure or other mailing label from us, please
						include it with your request, otherwise just include your mailing address.
					</span>
				</p>
				<p
					className='MsoListParagraph'
					style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: '"Courier New"' }}>
						o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
					</span>
					<span lang='EN-CA'>Emailing us at:</span>
				</p>
				<p className='MsoNormal' style={{ marginLeft: '.75in' }}>
					<span lang='EN-CA'>
						<a href='about:blank'>support@ordersimply.ca</a>{' '}
					</span>
				</p>
				<p className='MsoNormal' style={{ marginLeft: '.75in' }}>
					<span lang='EN-CA'>
						Note:{' '}
						<i>
							If you opt out from receiving further promotional emails from us, we
							will not share your email address with any third parties, including our
							Affiliates.
						</i>
					</span>
				</p>
				<p
					className='MsoListParagraph'
					style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
					<span lang='EN-CA' style={{ fontFamily: 'Symbol' }}>
						·
						<span style={{ font: '7.0pt "Times New Roman"' }}>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</span>
					<strong>
						<span lang='EN-CA'>From Order Simply, Inc. and its Affiliates</span>
					</strong>
					<em>
						<span
							lang='EN-CA'
							style={{ fontFamily: '"Calibri",sans-serif', fontStyle: 'normal' }}>
							.{' '}
						</span>
					</em>
					<span lang='EN-CA'>
						In addition, if you also prefer not to receive further product information
						and promotional mailings/emails from us based on information you provided to
						Order Simply, Inc., please indicate this in your instructions to us and
						please include your mailing address. Any promotional email will contain
						contact information/link and a reply email address to which you may reply to
						opt out from receiving similar future emails. Please note that your
						instructions do not govern the use of personal information you may have
						provided to third-party merchants whose products and services may be
						displayed or accessible on or through the Website. The use of information
						you have provided to these third-party merchants is governed by their
						privacy policies and terms. Also, your instructions do not apply to
						“transactional or relationship” email messages which include, but are not
						limited to, registration, order status, confirmation or reply emails. Your
						instructions will only apply to the Order Simply, Inc. Website, not to our
						Affiliates and their websites. Please refer to the policies and opt-out
						provisions of those other websites.&nbsp;
					</span>
				</p>
				<p className='MsoNormal' style={{ marginLeft: '.25in' }}>
					<span lang='EN-CA'>
						Your instructions to limit the use of your information will be processed as
						soon as reasonably practicable and in accordance with applicable
						law.&nbsp;Your instructions to opt-out of receiving promotional emails will
						be processed within 10 business days.
					</span>
				</p>
				<h1>
					<div id='retention_of_information' />
					<span lang='EN-CA'>Retention of personal information </span>
				</h1>
				<p
					style={{
						marginTop: '0in',
						marginRight: '0in',
						marginBottom: '12.0pt',
						marginLeft: '0in',
						textAlign: 'justify',
					}}>
					<span>
						We will retain your personal information for as long as necessary to fulfill
						the purposes for which it was collected, except where otherwise required or
						permitted by law. Once no longer required, your personal information will be
						securely destroyed or anonymized (so the information no longer identifies
						you). If you request your information to be deleted, it will be exterminated
						within ten days. Otherwise, it will be stored as an inactive account in case
						you choose to reactivate.
					</span>
				</p>
				<h1>
					<span lang='EN-CA'>Access and correction</span>
				</h1>
				<p className='MsoNormal' style={{ textAlign: 'justify' }}>
					<span lang='EN-CA'>
						You have the right to access and rectify the personal information we hold
						about you, subject to any legal restrictions. Upon request, we will provide
						you with access to your personal information within a reasonable timeframe,
						in compliance with applicable laws. It is your responsibility to provide
						accurate, correct and complete information.
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						If you have an Account, you can correct your personal information by logging
						into your Account and editing the data you want to change.
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						You can also request access or rectification by contacting us as described
						in the <a href='#contact_us'>Contact Us</a> section.
					</span>
				</p>
				<h1>
					<div id='your_consent' />
					<strong>
						<span lang='EN-CA'>Your consent</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						Subject to the above provisions, by using our Website, you consent to the
						collection and use of information by us and the terms of this Privacy
						Policy. Use of the Website constitutes agreement with all of the foregoing
						terms, and also constitutes permission to use your name, likeness,
						statements, quotes, testimonials and photographs for promotional purposes,
						including but not limited to posting of such information and reproduction
						and display on our Website or in any other communications, except where
						prohibited by law.
					</span>
				</p>
				<h1>
					<div id='changes' />
					<strong>
						<span lang='EN-CA'>Changes to this Policy&nbsp;</span>
					</strong>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						We may change our Privacy Policy from time to time and we will post those
						changes so that you are always aware of what information we collect, how we
						use it and under what circumstances we may disclose it.{' '}
					</span>
					<span lang='EN-CA' style={{ color: 'black', background: 'white' }}>
						If the changes we make are significant, we will provide a more prominent
						notice when required by applicable laws
					</span>
					<span lang='EN-CA'>. </span>
					<span lang='EN-CA'>
						In addition, if you would like prior notice of changes to the Privacy Policy
						or Terms of Use, email us at{' '}
						<a href='about:blank'>support@ordersimply.ca</a>
						from the email address to which you would like notice sent. By using
						www.OrderSimply.ca, after such changes and posting, you agree to be legally
						bound and to abide by the changes and other provisions contained in the
						Privacy Policy and Terms of Use of which this policy is a part.&nbsp;
					</span>
				</p>
				<h1>
					<div id='contact_us' />
					<strong>
						<span lang='EN-CA'>Contact us</span>
					</strong>
					<span lang='EN-CA'>&nbsp;</span>
				</h1>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						For questions regarding our privacy practices and this Privacy Policy,
						please contact us as follows:
					</span>
				</p>
				<p className='MsoNormal'>
					<span lang='EN-CA'>
						<a href='about:blank'>
							<span lang='FR'>support@ordersimply.ca</span>
						</a>
					</span>
					<span lang='FR'> </span>
				</p>
				<p className='MsoNormal'>
					<span lang='FR'>Suite 1602, 757 Victoria Park Avenue, Toronto, Ontario. </span>
				</p>
				<p className='MsoNormal'>
					<span lang='FR'>&nbsp;</span>
				</p>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
